<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import type { AddressModel } from '@/types/models/AddressModel'
import { EditableStringField } from '../Fields'

type Props = {
    address?: AddressModel
    isInEditMode: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AddressModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="16">
        <EditableStringField
            :label="$t('address.street')"
            :value="address?.street"
            :isInEditMode="isInEditMode"
            @change="street => $emit('change', { street })"
            required
            class="full-width" />
        <EditableStringField
            v-if="isInEditMode || address?.street2"
            :label="$t('address.street2')"
            :value="address?.street2"
            :isInEditMode="isInEditMode"
            @change="street2 => $emit('change', { street2 })"
            required
            class="full-width" />
        <EditableStringField
            v-if="isInEditMode || address?.street3"
            :label="$t('address.street3')"
            :value="address?.street3"
            :isInEditMode="isInEditMode"
            @change="street3 => $emit('change', { street3 })"
            required
            class="full-width" />

        <EditableStringField
            :label="$t('address.zipCode')"
            :value="address?.zip_code"
            :isInEditMode="isInEditMode"
            @change="zip_code => $emit('change', { zip_code })"
            required
            class="full-width" />
        <EditableStringField
            :label="$t('address.city')"
            :value="address?.city"
            :isInEditMode="isInEditMode"
            @change="city => $emit('change', { city })"
            required
            class="full-width" />
        <EditableStringField
            :label="$t('address.country')"
            :value="address?.country"
            :isInEditMode="isInEditMode"
            @change="country => $emit('change', { country })"
            required
            class="full-width" />
    </StackLayout>
</template>
